<form class="login-form"
      [formGroup]="formGroup"
      (ngSubmit)="onSubmitForm(formGroup.value)">
    <div class="form-section">
        <div class="row">
            <mat-form-field class="field">
                <input matInput
                       type="text"
                       placeholder="Username"
                       formControlName="username"
                       autocomplete="on"
                       id="username"
                       name="username">
                <mat-error *ngIf="formGroup.get('username').hasError('required')">
                    Field is required.
                </mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <hq-password-field class="field"
                               placeholder="Password"
                               formName="password"
                               autocomplete="on"
                               [shouldDisplayRequirements]="false"
                               [isValidationDisabled]="true"
                               [submitted]="hasSubmittedForm"
                               (markAsInitialized)="onAttachChildForm('password', $event)">
            </hq-password-field>
        </div>
        <div class="row button-container">
            <button mat-raised-button
                    type="submit"
                    class="button"
                    color="accent"
                    [disabled]="isLoggingIn">
                Log In
            </button>
        </div>
    </div>
</form>

<p class="forgot-password-link">
    <a [routerLink]="forgotPasswordRoute">Forgot Password?</a>
</p>

<p class="lead-link">
    Not a customer? <a href="https://www.spscommerce.com/products/community/in-aisle/retailer-contact-us/"
                       target="_blank">Click here</a> to schedule a demo!
</p>

<p class="build-version">Version: {{buildNumber}}</p>
